<template>
  <div @keydown="keydown" queue-auth-form-hook class="auth-form" :class="{'auth-form_logout':logout}">
    <div class="auth-form__top">
      <div class="auth-form__header">
        <div class="auth-form__header-wrapper">
          <div class="auth-form__header-main">
            <template v-if="!logout">
              <div class="auth-form__title">
                {{$t('auth.title')}}
              </div>
              <div class="auth-form__subtitle">
                {{$t('auth.subtitle')}}
              </div>
            </template>
          </div>
          <div class="auth-form__header-side">
            <IconCross @click="emitClose" class="icon-pointer"/>
          </div>
        </div>
      </div>
    </div>
    <div class="auth-form__middle">
      <div class="auth-form__form">
        <template v-if="!logout">
          <div class="auth-form__inputs">
            <div class="auth-form__inputs-item">
              <Input
                @input="setLogin"
                :value="login"
                :max-length="10"
                :placeholder="$t('auth.fields.login.placeholder')"
                :error-message="errorLogin"
                id="login"
                type="number"
                queue-login-input-hook
                full
              />
            </div>
            <div class="auth-form__inputs-item">
              <Input
                @input="setPassword"
                :value="password"
                :placeholder="$t('auth.fields.password.placeholder')"
                :error-message="errorPassword"
                id="password"
                queue-login-password-hook
                password
                full
              />
            </div>
          </div>
          <div class="auth-form__action">
            <Button queue-btn-login-hook :loading="loading" @click="emitLogin" full> {{$t('auth.action.primary')}}</Button>
          </div>
        </template>
        <template v-else>
          <div class="auth-form__action">
            <Button queue-btn-logout-hook :loading="loading" @click="emitLogout" full>{{$t('logout.action.primary')}}</Button>
          </div>
        </template>
        <div v-if="errorSubmit" class="auth-form__errors">
          <template v-if="errorSubmit.isKnown()">
            <span queue-error-message-title-hook v-if="errorSubmit.getMessage()">
               {{errorSubmit.getMessage()}}
            </span>
            <br>
            <span queue-error-message-desc-hook v-if="errorSubmit.getDescription()">
                {{errorSubmit.getDescription()}}
            </span>
          </template>
          <template v-else>
            <span queue-error-message-title-hook>
            {{$t('error.unknown')}}
            </span>
          </template>
        </div>
      </div>
    </div>
    <div class="auth-form__bottom">
      <div class="auth-form__bottom-wrapper">
        <div class="auth-form__bottom-side">
          <div class="auth-form__copyright">
            <div class="auth-form__copyright-main">
              {{$t('common.develop')}}
            </div>
            <div class="auth-form__copyright-side">
              <LogoCopyright class="auth-form__copyright-side-soft"/>
            </div>
          </div>
        </div>
        <div class="auth-form__bottom-main">
          <div class="auth-form__build">
            {{buildVersion}} | {{buildDate}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Helper from '@/utils/helper'
  import ApiBaseResponse from '@/app/service/api/api-base-response'
  // components
  import Input from '@/components/inputs/Input'
  import Button from '@/components/buttons/Button'
  import IconCross from '@/components/Icons/IconCross'
  import LogoCopyright from '@/components/logos/LogoCopyright'

  export default {
    name: 'AuthForm',
    props: {
      logout: {
        type: Boolean,
        required: false,
        default: false
      },
      reset: {
        type: Boolean,
        required: false,
        default: false
      },
      loading: {
        type: Boolean,
        required: false
      },
      errorSubmit: {
        type: ApiBaseResponse,
        required: false
      }
    },
    data () {
      return {
        login: null,
        password: null,
        errorLogin: null,
        errorPassword: null,
        buildDate: process.env.VUE_APP_BUILD,
        buildVersion: process.env.VUE_APP_VERSION
      }
    },
    components: {
      Input,
      Button,
      IconCross,
      LogoCopyright
    },
    watch: {
      reset () {
        if (this.reset) {
          if (!this.logout) {
            this.resetForm()
          }
        }
      }
    },
    methods: {
      keydown (value) {
        if (value.key === 'Enter') {
          this.emitLogin()
        }
      },
      setLogin (value) {
        this.login = value
        this.errorLogin = ''
      },
      setPassword (value) {
        this.password = value
        this.errorPassword = ''
      },
      resetForm () {
        this.login = null
        this.password = null
        this.errorPassword = null
        this.errorLogin = null
        for (const input of this.$el.querySelectorAll('input')) {
          input.value = ''
        }
      },
      emitClose () {
        this.$emit('close')
        this.resetForm()
      },
      emitLogout () {
        this.$emit('logout')
      },
      emitLogin () {
        let hasErrors = false
        if (!Helper.isDefined(this.login) || this.login.length === 0) {
          this.errorLogin = 'Значение не может быть пустым'
          hasErrors = true
        }

        if (Helper.isDefined(this.login)) {
          if (parseInt(this.login) > 2147483647) {
            this.errorLogin = 'Некорректное значение'
            hasErrors = true
          }
        }

        if (!Helper.isDefined(this.password) || this.password.length === 0) {
          this.errorPassword = 'Значение не может быть пустым'
          hasErrors = true
        }

        if (hasErrors) {
          return false
        }
        this.$emit('login', {
          login: this.login,
          password: this.password
        })
      }
    },
    mounted () {
      const id = this.$route.query.id
      const password = this.$route.query.password

      if (Helper.isDefined(id)) {
        this.login = id
      }
      if (Helper.isDefined(password)) {
        this.password = password
      }
    }
  }
</script>
